export const hasAllRequiredRoles = (
    userRoles: string[],
    requiredRoles: string[],
) => requiredRoles.every((role) => userRoles.includes(role));
